/**
 * auto-generated enum by saas-tool
 **/
export enum LOCALE_CATEGORIES {
  AI_ADOPTION = "ai_adoption",
  AI_ADOPTION_REPORT = "ai_adoption_report",
  BEHAVIOR_DEFINITION = "behavior_definition",
  BENCHMARK = "benchmark",
  CHRYSOBERYL = "chrysoberyl",
  DEMOGRAPHIC = "demographic",
  ERRORS = "errors",
  GENERIC = "generic",
  JOURNEY = "journey",
  LEXICON = "lexicon",
  NAVIGATION = "navigation",
  OMIND_ADVICE = "omind_advice",
  RECOMMENDATION = "recommendation",
  RESOURCES = "resources",
  SAPPHIRE = "sapphire",
  SIMULATION = "simulation",
  SKILL_DEFINITION = "skill_definition",
  THEME_DEFINITION = "theme_definition",
  TOURMALINE = "tourmaline",
}
